import WabaAccountBanner from "@/assets/images/banners/waba-account.jpg"
import SalesFunnelBanner from "@/assets/images/banners/sales-funnel.jpg"
import IcpInterviewBanner from "@/assets/images/banners/icp-interview.jpg"
import MessageBanner from "@/assets/images/banners/message.jpg"
import ActiveCampaignBanner from "@/assets/images/banners/active-campaign.jpg"
import AttendantsBanner from "@/assets/images/banners/attendants.jpg"
import BotBanner from "@/assets/images/banners/bot.jpg"
import BulkContactsBanner from "@/assets/images/banners/bulk-contacts.jpg"
import AIAgentsBanner from "@/assets/images/banners/ai-agents.png"
import DefaultBanner from "@/assets/images/banners/default.jpg"
import SalesFunnelTemporaryBanner from "@/assets/images/banners/sales-funnel-temporary.jpg"
import PaymentRecurrenceMigrationBanner from "@/assets/images/banners/payment-recurrence-migration.png"
import LetalkCommunityBanner from "@/assets/images/banners/letalk-community.png"
import Testimonial2StartBanner from "@/assets/images/banners/testimonial-2start-banner.png"
import SearchBaseBanner from "@/assets/images/banners/search-base.png"
import PlaygroundBanner from "@/assets/images/banners/playground-banner.png"
import MentoringWabaBanner from "@/assets/images/banners/mentoring-waba-banner.png"
import RebrandingBanner from "@/assets/images/banners/rebranding-banner.png"
import MgmBanner from "@/assets/images/banners/mgm-banner.png"
import AdminConsoleV1Banner from "@/assets/images/banners/admin-console-v1-banner.png"
import AIAgentsNewBanner from "@/assets/images/banners/agentes-de-ia-banner.png"
import GeneratorTemplatesBanner from "@/assets/images/banners/gerador-templates-banner.png"
import WhatsappBlockAlertBanner from "@/assets/images/banners/whatsapp-block-alert.png"
import MakeACallBanner from "@/assets/images/banners/make-a-call-banner.png"
import MetaCustoApiOficialBanner from "@/assets/images/banners/meta-custo-api-oficial.png"
import LechatBanner from "@/assets/images/banners/lechat-banner.png"
import { externalLinks, formsLinks, newsBannersDashboardLinks, whatsappLinks } from "@/utils/link"
import { playgroundIAUrl } from "@/config/url"
import HardCoded from "@/services/HardCoded"
import { ChannelType } from "@/protocols/channel"

export type Banner = {
	imageUrl: string
	linkUrl?: string
}

type BannersType =
	"sales-funnel" |
	"waba" |
	"icp-interview" |
	"attedants" |
	"bots" |
	"bulk-contacts" |
	"active-campaign" |
	"message" |
	"ai-agents-dashboard" |
	"default" |
	"sales-funnel-temporary" |
	"payment-recurrence-migration-banner" |
	"letalk-community-banner" |
	"ai-resource-testimonials" |
	"search-base-banner" |
	"playground-banner" |
	"mentoring-waba-banner" |
	"rebranding-banner" |
	"mgm-banner" |
	"admin-console-banner" |
	"ai-agents-banner" |
	"generator-templates-banner" |
	"whatsapp-block-alert-banner" |
	"make-a-call-banner" |
	"waba-cost-increase-banner" |
	"lechat-banner"

class BannerUtil {
	private readonly bannerTypeToBannerData: Record<BannersType, Banner> = {
		"ai-resource-testimonials": {
			imageUrl: Testimonial2StartBanner,
			linkUrl: newsBannersDashboardLinks.aiResourceRelease
		},
		"sales-funnel": {
			imageUrl: SalesFunnelBanner,
			linkUrl: newsBannersDashboardLinks.upgradeToUseSalesFunnel
		},
		waba: {
			imageUrl: WabaAccountBanner,
			linkUrl: newsBannersDashboardLinks.upgradeToWabaAccount
		},
		"icp-interview": {
			imageUrl: IcpInterviewBanner,
			linkUrl: newsBannersDashboardLinks.icpInterview
		},
		attedants: {
			imageUrl: AttendantsBanner,
			linkUrl: newsBannersDashboardLinks.upgradeAttendantsLimit
		},
		bots: {
			imageUrl: BotBanner,
			linkUrl: newsBannersDashboardLinks.upgradeActiveBotsLimit
		},
		"bulk-contacts": {
			imageUrl: BulkContactsBanner,
			linkUrl: newsBannersDashboardLinks.upgradeToUseBulkContacts
		},
		"active-campaign": {
			imageUrl: ActiveCampaignBanner,
			linkUrl: newsBannersDashboardLinks.upgradeToUseReceivedDataByActiveCampaign
		},
		message: {
			imageUrl: MessageBanner,
			linkUrl: newsBannersDashboardLinks.upgradeMessageDailyLimit
		},
		"ai-agents-dashboard": {
			imageUrl: AIAgentsBanner,
			linkUrl: newsBannersDashboardLinks.aiAgentsDashboard
		},
		default: {
			imageUrl: DefaultBanner,
			linkUrl: newsBannersDashboardLinks.upgradeToAdvancedPlan
		},
		"sales-funnel-temporary": {
			imageUrl: SalesFunnelTemporaryBanner,
			linkUrl: newsBannersDashboardLinks.salesFunnelTemporary
		},
		"payment-recurrence-migration-banner": {
			imageUrl: PaymentRecurrenceMigrationBanner,
			linkUrl: newsBannersDashboardLinks.paymentRecurrenceMigration
		},
		"letalk-community-banner": {
			imageUrl: LetalkCommunityBanner,
			linkUrl: newsBannersDashboardLinks.letalkCommunity
		},
		"search-base-banner": {
			imageUrl: SearchBaseBanner,
			linkUrl: newsBannersDashboardLinks.searchBase
		},
		"playground-banner": {
			imageUrl: PlaygroundBanner,
			linkUrl: playgroundIAUrl.cpURL as string
		},
		"mentoring-waba-banner": {
			imageUrl: MentoringWabaBanner,
			linkUrl: newsBannersDashboardLinks.mentoringWaba
		},
		"rebranding-banner": {
			imageUrl: RebrandingBanner
		},
		"mgm-banner": {
			imageUrl: MgmBanner,
			linkUrl: formsLinks.partnerships
		},
		"admin-console-banner": {
			imageUrl: AdminConsoleV1Banner,
			linkUrl: newsBannersDashboardLinks.adminConsole
		},
		"ai-agents-banner": {
			imageUrl: AIAgentsNewBanner,
			linkUrl: whatsappLinks.interestAgentsAI
		},
		"generator-templates-banner": {
			imageUrl: GeneratorTemplatesBanner,
			linkUrl: externalLinks.generatorTemplates
		},
		"whatsapp-block-alert-banner": {
			imageUrl: WhatsappBlockAlertBanner,
			linkUrl: whatsappLinks.sendMessageWhatsappBlockAlert
		},
		"make-a-call-banner": {
			imageUrl: MakeACallBanner,
			linkUrl: newsBannersDashboardLinks.letalkInbox
		},
		"waba-cost-increase-banner": {
			imageUrl: MetaCustoApiOficialBanner,
			linkUrl: newsBannersDashboardLinks.wabaCostIncrease
		},
		"lechat-banner": {
			imageUrl: LechatBanner,
			linkUrl: whatsappLinks.interestLechat
		}
	}

	mountBanners (channelType?: ChannelType): Banner[] {
		const banners: Banner[] = []
		// const aiCreditsPermissionLimit = useSubscriptionLimits("permission", "ai_resources")

		const bannersTypeToEnabledBanner: Record<BannersType, boolean> = {
			"playground-banner": false, // !aiCreditsPermissionLimit.isLoading && (HardCoded.checkFeatureFlag("playgroundAIBetaTesters") || !aiCreditsPermissionLimit.mustBlock),
			"ai-resource-testimonials": false, // true,
			"payment-recurrence-migration-banner": false, // HardCoded.checkFeatureFlag("canShowPaymentRecurrenceMigrationBanner"),
			"sales-funnel-temporary": false,
			bots: false, // HardCoded.checkFeatureFlag("canShowBotBanner"),
			"active-campaign": false, // HardCoded.checkFeatureFlag("canShowActiveCampaignBanner"),
			"bulk-contacts": false, // HardCoded.checkFeatureFlag("canShowBulkContactsBanner"),
			attedants: false, // HardCoded.checkFeatureFlag("canShowAttendantsBanner"),
			message: false, // HardCoded.checkFeatureFlag("canShowMessagesBanner"),
			"ai-agents-dashboard": false,
			default: false, // HardCoded.checkFeatureFlag("canShowDefaultBanner"),
			"icp-interview": false,
			"sales-funnel": false,
			waba: false,
			"letalk-community-banner": false,
			"search-base-banner": false,
			"mentoring-waba-banner": false,
			"rebranding-banner": false,
			"mgm-banner": false,
			"admin-console-banner": false,
			"ai-agents-banner": false,
			"generator-templates-banner": false,
			"whatsapp-block-alert-banner": HardCoded.checkFeatureFlag("canShowWhatsappBlockAlertBanner"),
			"make-a-call-banner": false,
			"waba-cost-increase-banner": channelType === "waba",
			"lechat-banner": true
		}

		for (const key in bannersTypeToEnabledBanner) {
			if (bannersTypeToEnabledBanner[key as BannersType]) {
				banners.push(this.bannerTypeToBannerData[key as BannersType])
			}
		}

		return banners
	}
}

export default new BannerUtil()
